import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  min-height: 50vh;
  display: grid;
  place-items: center;
`;

const Loader = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 5px solid rgba(0, 99, 65, 0.15);
  border-top-color: ${({ theme }) => theme.colors.primary};
  animation: ${spin} 0.8s linear infinite;
`;

const FullPageSpinner = () => (
  <Wrapper>
    <Loader role="status" aria-label="جار التحميل" />
  </Wrapper>
);

export default FullPageSpinner;
